import { excuseApi } from "../commons/http";

class UserSupportHistory {
  constructor(data = {}) {
    this.id = data.id;
    this.user_id = data.user_id;
    this.support_type = data.support_type;
    this.title = data.title;
    this.description = data.description;
    this.resolution = data.resolution;
    this.handled_by = data.handled_by;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.user = data.user;
    this.handler = data.handler;
  }

  async save() {
    try {
      const res = await excuseApi({
        path: '/user-support-history',
        method: 'POST',
        body: {
          user_id: this.user_id,
          support_type: this.support_type,
          title: this.title,
          description: this.description,
          resolution: this.resolution
        }
      });
      
      if (res.status === 200 || res.status === 201) {
        return { success: true, message: "Thêm lịch sử hỗ trợ thành công!" };
      }
      return { success: false, message: "Không thể thêm lịch sử hỗ trợ" };
    } catch (error) {
      throw error;
    }
  }

  async update() {
    try {
      const res = await excuseApi({
        path: `/user-support-history/${this.id}`,
        method: 'PUT',
        body: {
          support_type: this.support_type,
          title: this.title,
          description: this.description,
          resolution: this.resolution
        }
      });
      
      if (res.status === 200) {
        return { success: true, message: "Cập nhật lịch sử hỗ trợ thành công!" };
      }
      return { success: false, message: "Không thể cập nhật lịch sử hỗ trợ" };
    } catch (error) {
      throw error;
    }
  }

  async delete() {
    try {
      const res = await excuseApi({
        path: `/user-support-history/${this.id}`,
        method: 'DELETE'
      });
      
      if (res.status === 200) {
        return { success: true, message: "Xóa lịch sử hỗ trợ thành công!" };
      }
      return { success: false, message: "Không thể xóa lịch sử hỗ trợ" };
    } catch (error) {
      throw error;
    }
  }

  static async getByUserId(userId, page = 1, perPage = 20) {
    try {
      const res = await excuseApi({
        path: '/user-support-history',
        method: 'GET',
        params: {
          user_id: userId,
          page: page,
          per_page: perPage
        }
      });
      
      if (res.status === 200) {
        return {
          data: res.data.data.map(item => new UserSupportHistory(item)),
          pagination: res.data.pagination
        };
      }
      return { data: [], pagination: null };
    } catch (error) {
      throw error;
    }
  }

  static async getById(id) {
    try {
      const res = await excuseApi({
        path: `/user-support-history/${id}`,
        method: 'GET'
      });
      
      if (res.status === 200) {
        return new UserSupportHistory(res.data.data);
      }
      return null;
    } catch (error) {
      throw error;
    }
  }
}

export default UserSupportHistory;